export default __webpack_public_path__ + "static/media/kitchen5-beforeA-1440w.3f08da2e.png";